import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import { useLocation } from '@reach/router'
import Layout from '../components/layout'
import WpTagPage from '../components/WpTagPage'
import { mapLocaleData } from '../utils'

const TagTemplate = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const navBarData = data.contentfulNavigationBar
  const footerData = data.contentfulFooterV2
  const tagData = data.wpTag
  const defaultdata = data.wp.generalSettings
  const siteLanguages = data.site.siteMetadata.languages
  const latestBlogPost = data.latestPost.edges[0].node
  const location = useLocation()
  return (
    <Layout
      latestBlogPost={latestBlogPost}
      navBarData={navBarData}
      footerData={footerData}
      siteLanguages={siteLanguages}
      location={location}
    >
      <div style={{ background: '#fff' }}>
        <Helmet title={siteTitle} />
        <WpTagPage
          data={tagData}
          defaultdata={defaultdata}
          location={location}
        />
      </div>
    </Layout>
  )
}

export default TagTemplate

export const pageQuery = graphql`
  fragment tag on WpTag {
    uri
    name
    id
    count
    link
    termTaxonomyId
    termGroupId
    databaseId
    description
    nodeType
    slug
    locale {
      locale
    }
    posts {
      nodes {
        ...previewCardQuery
      }
    }
  }

  query ($id: String!) {
    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }

    latestPost: allWpPost(
      sort: { fields: date, order: DESC }
      limit: 1
      filter: { locale: { locale: { eq: "en_US" } }, status: { eq: "publish" } }
    ) {
      edges {
        node {
          ...LatestPost
        }
      }
    }

    contentfulNavigationBar(node_locale: { eq: "en-US" }) {
      ...ContentfulNavQuery
    }

    wp {
      ...GeneralSettings
    }

    wpTag(id: { eq: $id }, locale: { locale: { eq: "en_US" } }) {
      ...tag
    }

    contentfulFooterV2(node_locale: { eq: "en-US" }) {
      ...ContentfulFooterQuery
    }
  }
`
